import PropTypes from 'prop-types'

// @mui
import { Stack } from '@mui/material'
// components
//
import Render from '../../components/Render'
import { StyledContent, StyledRoot, StyledSectionBg } from './styles'
import { useWhiteLabel } from '../../hooks/useWhiteLabel'
import useImageLoader from '../../hooks/useImageLoader'

// ----------------------------------------------------------------------

LoginLayout.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  illustration: PropTypes.string,
}

export default function LoginLayout({ children, title }) {
  const { whitelabel } = useWhiteLabel()

  const whitlebelSlug = whitelabel?.name?.toLowerCase()?.split(' ')?.join('-')

  const image = useImageLoader(`/assets/background/whitelabels/${whitlebelSlug}/login.webp`)

  return (
    <StyledRoot>
      <StyledContent>
        <Stack sx={{ width: 1, height: '100%' }}> {children} </Stack>
      </StyledContent>

      <Render if={image.loading || image.url}>
        <Stack
          sx={{
            padding: 2,
            width: '100%',
            display: {
              xs: 'none',
              lg: 'flex',
            },
            flex: {
              lg: image.url ? 1 : 0,
            },
          }}
        >
          <Stack
            zIndex={1}
            sx={{
              flex: 1,
              position: 'relative',
              overflow: 'hidden',
              borderRadius: 8,
              zIndex: 1,
              '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundImage: `url(${image.url})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                opacity: 0.4,
                zIndex: -1,
              },
              '&::after': {
                content: '""',
                position: 'absolute',
                bottom: 0,
                left: 0,
                width: '100%',
                height: '40%',
                background: 'linear-gradient(to top, rgba(0,0,0,0.5), transparent)',
                zIndex: 0,
              },
            }}
          ></Stack>
        </Stack>
      </Render>

      <StyledSectionBg />
    </StyledRoot>
  )
}
